import { render, staticRenderFns } from "./BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiTalepEvrakForm.vue?vue&type=template&id=722fd06b"
import script from "./BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports